import React, {FC} from "react";
import {
  Head,
  TableTitle,
  TableTitleWrapper,
} from "./styles";
import { ChevronIc } from "../header/styles";
import CheckBox from "../checkbox";
import { icons } from "../../icons";
import { useQueryParam, StringParam, NumberParam } from 'use-query-params';
import styled from "styled-components";
import { useTranslation } from "react-i18next";
const Th = styled.th`

`;
const Tr = styled.tr`


`

const Thead = styled.thead`
/* display: flex; */
/* width: 100%; */
  height: 42px;
  /* padding-left: 10px; */
  background-color: ${({theme}) => theme.palette[200]};
  border-collapse: none;

  @media (max-width: 768px) {
    display: none;
  }
`

const TableColumnItem:FC<any> = 
  ({
    columns,
    hideCheckbox,
    hideOther,
    allChecked,
    checked,
    canSelectAll,
    toggleAll,
  }) => {


  const foundedProps = columns.find((column:any) => column.key === 'props' || column.key === 'eye')
  const columnWidth = `calc(${100 / (foundedProps ? columns.length - 1 : columns.length)}% - 10px)`;

  return(
    <Thead>
      <Tr>
        {columns.map((column:any) => (
          <Item
            key={column.key}
            hideOther={hideOther}
            column={column}
            checked={checked}
            columnWidth={columnWidth}
            allChecked={allChecked}
            hideCheckbox={hideCheckbox}
            canSelectAll={canSelectAll}
            toggleAll={toggleAll}
          />
        ))}
      </Tr>
    </Thead>
  )
}

export default TableColumnItem

const Item = (props:any) => {
  const {
    column,
    columnWidth,
    allChecked,
    checked,
    hideOther,
    hideCheckbox,
    canSelectAll,
    toggleAll,
  } = props;
  const [ordering, setOrdering] = useQueryParam('ordering', StringParam);
  const [, setPage] = useQueryParam('page', NumberParam);
  const [t] = useTranslation()
  const orderingKey = column.orderingKey || column.key
  const ascending = ordering === orderingKey
  const descending = ordering === `-${orderingKey}`
  const sortable = Boolean(column.sorted && !hideOther)
  return(
    <Th
      aria-sort={sortable ? ascending ? 'ascending' : descending ? 'descending' : 'none' : undefined}
      style={column.key === 'props' || column.key === 'eye' ? {marginRight:'20px'} : {width:columnWidth}}
    >
      <Head>
      {(column.key === 'floating_ip_address' || column.key === 'direction' || column.key === 'name' || column.key === 'port' || column.key === 'id') && !hideCheckbox && canSelectAll ?
      <CheckBox
        value={allChecked}
        indeterminate={Boolean(checked?.length) && !allChecked}
        test_id={'main-checkbox'}
        ariaLabel={t('SELECT_ALL')}
        title=''
        onChange={toggleAll}
      />
      : null}
      <TableTitleWrapper onClick={() => {
        if(hideOther || !column.sorted){
          return 
        } else {
          setOrdering(ordering === orderingKey ? `-${orderingKey}` : orderingKey)
          setPage(1)
        }
      }}>
        <TableTitle>
          {column.title}
        </TableTitle>
        {!column.sorted || hideOther ? null :
          <ChevronIc
            active={ascending}
            alt=""
            src={icons.Chevron}
            style={{opacity: ascending || descending ? 1 : 0.45}}
          />
        }
      </TableTitleWrapper>
      {/* {column.title} */}
      </Head>
    </Th>
  )
}
